import { createContext, MouseEvent } from 'react'
import { TeamMemberInvite } from 'src/interfaces/team'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface ITeamMemberInvitesTableContext extends IColumnManagerContext {
  refreshTeamMemberInvites(): void

  actionAnchor: null | HTMLElement
  teamMemberInviteToAction: TeamMemberInvite | null
  openTeamMemberInviteItemAction(
    event: MouseEvent<HTMLButtonElement>,
    TeamMemberInvite: TeamMemberInvite,
  ): void
  closeTeamMemberInviteItemAction(): void
}

export const TeamMemberInvitesTableContext = createContext<ITeamMemberInvitesTableContext>({
  ...defaultColumnManagerContext,

  refreshTeamMemberInvites: () => {},

  actionAnchor: null,
  teamMemberInviteToAction: null,
  openTeamMemberInviteItemAction: () => {},
  closeTeamMemberInviteItemAction: () => {},
})
